var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 584.765,
    height: 383.035,
    viewBox: "0 0 584.765 383.035",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#13c4fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0533b3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1061.735 -999.582)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-432.555,2197.193s-54.777-82.606,0-181.437c0,0,88.545,65.578,56.7,181.437Z",
    transform: "translate(1518.636 -814.576)",
    fill: "#f9ae30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-367.806,2129.686c-.064-.589-.128-1.177-.2-1.762-9.225,13.054-19.25,25.628-30.464,36.26-2.57-20.285-5.982-41.321-9.8-61.347l.045.031a377.238,377.238,0,0,0,21.057-34.575c-.224-.413-.451-.822-.676-1.229a376.115,376.115,0,0,1-20.725,34.2c-6.655-34.639-14.484-66.062-21.2-85-.426-.333-.662-.507-.662-.507-.155.277-.3.555-.449.833,6.664,18.731,14.447,49.919,21.077,84.369-15.634-11.9-29.11-22.758-40.725-32.827-.1.435-.2.873-.292,1.308,11.787,10.195,25.461,21.193,41.349,33.256,3.866,20.271,7.32,41.6,9.9,62.14a299.532,299.532,0,0,1-51.871-23.646c.1.516.2,1.025.3,1.534a300.177,300.177,0,0,0,51.73,23.421c1.325,10.664,2.412,21.1,3.2,31.048h1.178c-.8-10.1-1.907-20.713-3.261-31.552C-387.059,2155.117-377.031,2142.651-367.806,2129.686Z",
    transform: "translate(1513.505 -814.576)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1102.507 1035.355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M553.6,173.936H98.988A18.938,18.938,0,0,0,80.05,192.874V480.935a18.939,18.939,0,0,0,18.938,18.938h60.339v-9.23a4.916,4.916,0,0,1,4.915-4.917h324.1a4.917,4.917,0,0,1,4.917,4.917v9.23H553.6a18.939,18.939,0,0,0,18.939-18.938V192.874A18.938,18.938,0,0,0,553.6,173.936Z",
    transform: "translate(-80.05 -173.936)",
    fill: "#222f3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.6,173.936H98.988A18.938,18.938,0,0,0,80.05,192.874V480.935a18.939,18.939,0,0,0,18.938,18.938h60.339v-9.23a4.916,4.916,0,0,1,4.915-4.917h324.1a4.917,4.917,0,0,1,4.917,4.917v9.23H553.6a18.939,18.939,0,0,0,18.939-18.938V192.874A18.938,18.938,0,0,0,553.6,173.936Z",
    transform: "translate(-80.05 -173.936)",
    fill: "#222f3e",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("rect", {
    width: 566.9,
    height: 14.189,
    transform: "translate(1065.301 1354.198)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 566.9,
    height: 14.189,
    transform: "translate(1065.301 1354.198)",
    fill: "#e5e5e5",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.087,406.329l8.775,7.028a32.622,32.622,0,0,0,20.4,7.161h508.56a32.619,32.619,0,0,0,20.4-7.161l8.775-7.028Z",
    transform: "translate(1011.214 962.059)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.087,406.329l8.775,7.028a32.622,32.622,0,0,0,20.4,7.161h508.56a32.619,32.619,0,0,0,20.4-7.161l8.775-7.028Z",
    transform: "translate(1011.214 962.059)",
    fill: "#222f3e",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.868,396.891a6.631,6.631,0,0,0,6.631,6.631h95.689a6.629,6.629,0,0,0,6.629-6.631c0-.159-.036-.308-.046-.464H213.915C213.9,396.583,213.868,396.732,213.868,396.891Z",
    transform: "translate(1080.408 957.77)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1123.351 1064.35)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 449.5,
    height: 255.832,
    transform: "translate(0 0)",
    fill: "#f9f9f9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1238.445 1129.155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-912.617,1648.647h-208.746l-10.958-110.2,219.7-16.437Z",
    transform: "translate(1132.321 -1522.008)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1016.99,1608.718l-115.331-70.273,219.7-16.437Z",
    transform: "translate(1132.321 -1522.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-912.617,1522.008l-105.407,77.866-114.3-61.429",
    transform: "translate(1132.321 -1522.008)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.032 97.428)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.606,
    height: 3.531,
    transform: "translate(0 5.8)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.606,
    height: 3.531,
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 48.606,
    height: 3.531,
    transform: "translate(0 11.601)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1307.746 1003.721)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-860.632,1222.459a44.2,44.2,0,0,0-58.2-22.788,44.2,44.2,0,0,0-22.788,58.2,44.02,44.02,0,0,0,9.314,13.576c-1.544,3.7-4.3,12.4-4.3,12.4s7.92-4.834,11.343-6.682a44.136,44.136,0,0,0,41.84,3.491A44.2,44.2,0,0,0-860.632,1222.459Z",
    transform: "translate(945.333 -1195.958)",
    fill: "#fff",
    stroke: "#222f3e",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.916 37.142)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6,
    cy: 7,
    rx: 6,
    ry: 7,
    transform: "translate(0.337 0.137)",
    fill: "#f9ae30"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.5,
    cy: 7,
    rx: 7.5,
    ry: 7,
    transform: "translate(17.337 0.137)",
    fill: "#f9ae30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    transform: "translate(38.337 0.137)",
    fill: "#f9ae30"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1550.62 1231.042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-329.358,1961.167s45.762-69.009,0-151.575c0,0-73.971,54.785-47.366,151.575Z",
    transform: "translate(404.9 -1809.592)",
    fill: "#a9dcb5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-379.752,1904.771c.054-.491.107-.984.165-1.471,7.707,10.9,16.082,21.41,25.45,30.29,2.147-16.944,5-34.52,8.185-51.249l-.038.026a315.268,315.268,0,0,1-17.591-28.882c.188-.346.376-.687.565-1.027a314.123,314.123,0,0,0,17.315,28.573c5.559-28.937,12.1-55.189,17.709-71.011.356-.279.553-.426.553-.426.129.233.248.464.375.7-5.567,15.649-12.07,41.7-17.608,70.484,13.06-9.94,24.319-19.012,34.022-27.425.081.364.167.729.244,1.093-9.847,8.518-21.27,17.706-34.543,27.783-3.23,16.935-6.115,34.754-8.274,51.912a250.276,250.276,0,0,0,43.333-19.753q-.125.644-.255,1.281a250.8,250.8,0,0,1-43.216,19.566c-1.107,8.908-2.015,17.626-2.67,25.938h-.984c.666-8.441,1.593-17.3,2.724-26.358C-363.667,1926.017-372.045,1915.6-379.752,1904.771Z",
    transform: "translate(402.981 -1809.592)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-444.891,2105.255s-27.02-40.748,0-89.5c0,0,43.677,32.348,27.968,89.5Z",
    transform: "translate(456.901 -1953.681)",
    fill: "#f9ae30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-410.181,2071.955c-.032-.291-.063-.581-.1-.869a119.967,119.967,0,0,1-15.027,17.886c-1.268-10.005-2.951-20.383-4.833-30.261l.022.015a186.051,186.051,0,0,0,10.387-17.054q-.166-.305-.334-.607a185.508,185.508,0,0,1-10.223,16.871c-3.283-17.087-7.145-32.587-10.457-41.93-.21-.164-.327-.25-.327-.25-.076.137-.146.274-.222.411,3.287,9.24,7.126,24.624,10.4,41.618-7.712-5.868-14.359-11.226-20.089-16.193-.048.215-.1.431-.144.645,5.814,5.029,12.559,10.454,20.4,16.4,1.907,10,3.611,20.521,4.886,30.653a147.769,147.769,0,0,1-25.587-11.664c.049.254.1.506.15.756a148.061,148.061,0,0,0,25.517,11.553c.654,5.26,1.19,10.408,1.577,15.315h.581c-.393-4.984-.941-10.217-1.609-15.563A118,118,0,0,0-410.181,2071.955Z",
    transform: "translate(453.078 -1953.681)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactLaptop);
export default __webpack_public_path__ + "static/media/contact-laptop.f70861c10f1345e29a4a283658f67f0f.svg";
export { ForwardRef as ReactComponent };